var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-theme',_vm._g(_vm._b({class:[
		_vm.$s.Card,
		_vm.$s[("shape_" + _vm.resolvedShape)],
		_vm.$s[("variant_" + _vm.resolvedVariant)] ],style:(_vm.style),attrs:{"theme":_vm.cardTheme,"aria-labelledby":_vm.ariaLabelledby}},'m-theme',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }